/* ==========================================================================
   SERPROMAQ - PUNTO DE ENTRADA PRINCIPAL (MAIN JS)
   ========================================================================== */

import '../styles/variables.css';
import '../styles/base.css';
import '../styles/layout.css';
import '../styles/components.css';
import '../styles/animations.css';
import '../styles/admin.css';
import '../styles/responsive.css';

import { initNavigation } from './navigation.js';
import { initCatalog } from './catalog.js';
import { initQuoteModal } from './quote-modal.js';
import { initWhatsAppWidget } from './whatsapp.js';
import { initCountersAndAnimations } from './counters.js';
import { initFullPageScroll } from './fullpage-scroll.js';
import { initRecruitmentModule } from './recruitment.js';
import { initAboutModule } from './about.js';
import { initReviewsModule } from './reviews.js';
import { initContactModule } from './contact.js';
import { initAdminDashboard } from './admin-dashboard.js';
import { BRANDS } from '../data/brands-data.js';

document.addEventListener('DOMContentLoaded', () => {
  // Render Brands Carousel/Grid
  const brandsGrid = document.getElementById('brandsGrid');
  if (brandsGrid) {
    brandsGrid.innerHTML = BRANDS.map(brand => `
      <div class="brand-item">
        <span>${brand.name}</span>
      </div>
    `).join('');
  }

  // Initialize Modules
  initNavigation();
  initCatalog();
  initQuoteModal();
  initWhatsAppWidget();
  initCountersAndAnimations();
  initFullPageScroll();
  initRecruitmentModule();
  initAboutModule();
  initReviewsModule();
  initContactModule();
  initAdminDashboard();

  console.log('🚀 SERPROMAQ Web Platform & Admin Dashboard Initialized Successfully.');
});
